import React, { useEffect, useState } from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import useSound from "use-sound";
import { desktop, mobile } from "../../theme";

import playSvg from "./play.svg";
import pauseSvg from "./pause.svg";

const Parent = styled("div")(
  css({
    cursor: "pointer",
    boxSizing: "border-box",
    padding: "15px 30px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 92,
    backgroundColor: "#fff",
    fontSize: [2, 3],
    span: {
      marginRight: 30,
    },
    [desktop]: {
      margin: "30px 0 120px",
    },
    [mobile]: {
      margin: "30px 0",
      width: "100%",
    },
  })
);

export const Audio = ({ src }) => {
  const [play, { sound }] = useSound(src);
  const [playState, setPlayState] = useState(false);

  useEffect(() => {
    const onPlay = () => {
      setPlayState(true);
    };
    sound?.on("play", onPlay);

    const onEnd = () => {
      setPlayState(false);
    };
    sound?.on("pause", onEnd);
    sound?.on("end", onEnd);

    return () => {
      sound?.off("play", onPlay);
      sound?.off("pause", onEnd);
      sound?.off("end", onEnd);
    };
  }, [sound]);

  return (
    <Parent
      onClick={() => {
        if (!playState) {
          play();
        } else {
          sound?.pause();
        }
      }}
    >
      <span>Послушать</span>
      <img alt="" src={!playState ? playSvg : pauseSvg} />
    </Parent>
  );
};
